import React, { Component } from 'react'
import { Table, Button } from 'react-bootstrap'
import 'react-date-range/dist/styles.css' // main style file
import 'react-date-range/dist/theme/default.css' // theme css file
import { DateRangePicker } from 'react-date-range'
import GetCreatorAnalytics from '../../Services/Queries/GetCreatorAnalytics'
import _ from 'lodash'
import { ToastContainer, toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import DatePicker from 'react-datepicker'
import AwsConfig from '../../Config/AwsConfig'

import 'react-datepicker/dist/react-datepicker.css'
import { creatorAnalyticsHeadings } from '../Data/StaticData'
class ListPages extends React.Component {
	toastStyle = {
		position: 'top-right',
		autoClose: 5000,
		hideProgressBar: false,
		closeOnClick: true,
		pauseOnHover: true,
		draggable: true,
		progress: undefined,
	}
	constructor(props) {
		super(props)

		this.state = {
			selectedDate: new Date(),
			limit: 25,
			nextToken: null,
			headings: creatorAnalyticsHeadings,
			analyticsData: [],
		}

		this.loadMore = this.loadMore.bind(this)
	}
	loadMore = async () => {
		await this.getNextCreatorAnalyticsData()
	}
	getFormattedDate = (date) => {
		var dd = date.getDate()
		var mm = date.getMonth() + 1

		var yyyy = date.getFullYear()
		if (dd < 10) {
			dd = '0' + dd
		}
		if (mm < 10) {
			mm = '0' + mm
		}
		var formattedDate = yyyy + '/' + mm + '/' + dd

		return formattedDate
	}
	getFormattedDateTime = (date) => {
		var hh = date.getHours()
		var m = date.getMinutes()
		var d = 'AM'
		var h = hh
		if (h >= 12) {
			h = hh - 12
			d = 'PM'
		}
		if (h == 0) {
			h = 12
		}
		m = m < 10 ? '0' + m : m
		const formattedTime = h + ':' + m + ' ' + d
		return this.getFormattedDate(date) + ' ' + formattedTime
	}

	getCreatedDate = (time) => {
		const dateObj = new Date(parseInt(time))
		const formattedDate = this.getFormattedDateTime(dateObj)
		return formattedDate
	}
	getCreatorAnalyticsData = async () => {
		const dateObj = new Date()
		const formattedDate = this.getFormattedDate(dateObj)
		const input = {
			date: formattedDate,
		}
		console.log(input, 'inputttt')
		const data = await GetCreatorAnalytics(input)
		console.log(data, 'dataaaaa')
		this.setState({
			analyticsData: data.items,
			nextToken: data.nextToken,
		})
	}

	getNextCreatorAnalyticsData = async () => {
		const { selectedDate } = this.state
		const formattedDate = this.getFormattedDate(selectedDate)
		const input = {
			date: formattedDate,
			nextToken: this.state.nextToken,
		}
		const data = await GetCreatorAnalytics(input)
		this.setState({
			analyticsData: [...this.state.analyticsData, ...data.items],
			nextToken: data.nextToken,
		})
	}
	filterData = async () => {
		const { selectedDate } = this.state
		const formattedDate = this.getFormattedDate(selectedDate)

		const input = {
			date: formattedDate,
		}
		console.log(input, 'inputttt')
		const data = await GetCreatorAnalytics(input)
		console.log(data, 'dataaaaa')
		this.setState({
			filtered: true,
			analyticsData: data.items,
			nextToken: data.nextToken,
		})
	}
	resetFilter = () => {
		this.setState({ selectedDate: new Date() })
		this.getCreatorAnalyticsData()
	}
	async componentDidMount() {
		this.getCreatorAnalyticsData()
	}

	renderTable = (heading, contentList) => {
		return (
			<Table striped bordered hover>
				<thead>
					<tr>
						{heading.map((head) => (
							<th style={{ fontSize: '12px', verticalAlign: 'middle' }}>{head}</th>
						))}
					</tr>
				</thead>
				<tbody>{contentList.map((row, index) => this.renderTableRow(row, index))}</tbody>
			</Table>
		)
	}

	renderTableRow = (item, index) => {
		const cdnurl = AwsConfig.cdn_url
		let imageUri = item.userProfilePicURL
		if (imageUri && !imageUri.includes(cdnurl)) {
			imageUri = cdnurl + item.userProfilePicURL
		}
		// const pageValue = item.pageValue
		// const PK = pageValue.replace('page#', '')
		return (
			<tr>
				<td style={{ fontSize: '12px' }}> {index + 1}</td>
				<td style={{ fontSize: '12px', minWidth: '100px' }}>{item.creatorName}</td>
				<td style={{ fontSize: '12px', minWidth: '100px' }}>{item.creatorHandle}</td>

				<td style={{ fontSize: '12px', minWidth: '50px' }}>
					{item.noOfContentsCreated ? item.noOfContentsCreated : '-'}
				</td>
				<td style={{ fontSize: '12px', minWidth: '50px' }}>
					{item.noOfContentsPublished ? item.noOfContentsPublished : '-'}
				</td>
				<td style={{ fontSize: '12px', minWidth: '50px' }}>
					{item.noOf_Telugu_ContentsCreated ? item.noOf_Telugu_ContentsCreated : '-'}
				</td>
				<td style={{ fontSize: '12px', minWidth: '50px' }}>
					{item.noOf_Hindi_ContentsCreated ? item.noOf_Hindi_ContentsCreated : '-'}
				</td>
				<td style={{ fontSize: '12px', minWidth: '50px' }}>
					{item.noOf_English_ContentsCreated ? item.noOf_English_ContentsCreated : '-'}
				</td>
				<td style={{ fontSize: '12px', minWidth: '50px' }}>
					{item.noOf_Telugu_ContentsPublished ? item.noOf_Telugu_ContentsPublished : '-'}
				</td>
				<td style={{ fontSize: '12px', minWidth: '50px' }}>
					{item.noOf_Hindi_ContentsPublished ? item.noOf_Hindi_ContentsPublished : '-'}
				</td>
				<td style={{ fontSize: '12px', minWidth: '50px' }}>
					{item.noOf_English_ContentsPublished ? item.noOf_English_ContentsPublished : '-'}
				</td>
				<td style={{ fontSize: '12px', minWidth: '100px' }}>
					<img style={{ maxWidth: '100%', height: 50 }} src={imageUri} />
				</td>
				<td style={{ fontSize: '12px', minWidth: '300px' }}>{item.creatorUUID}</td>
				<td style={{ fontSize: '12px', minWidth: '50px' }}>
					{item.createdDateTime ? this.getCreatedDate(item.createdDateTime) : '-'}
				</td>
			</tr>
		)
	}

	render() {
		const { analyticsData, headings } = this.state
		return (
			<section className='feed'>
				<ToastContainer
					position='top-right'
					autoClose={5000}
					hideProgressBar={false}
					newestOnTop={false}
					closeOnClick
					rtl={false}
					pauseOnFocusLoss
					draggable
					pauseOnHover
				/>
				<div>
					<label>Creator Analytics</label>
				</div>

				<div class='row'>
					<div class='col-md-4'>
						<text>Choose Date:</text>
						<DatePicker
							dateFormat={'dd/MM/yyyy'}
							maxDate={new Date()}
							selected={this.state.selectedDate}
							onChange={(date) => this.setState({ selectedDate: date })}
						/>
					</div>
					<div class='col-md-4'>
						<Button
							style={{ marginRight: 10 }}
							onClick={() => {
								this.filterData()
							}}
						>
							Filter
						</Button>
						<Button
							onClick={() => {
								this.resetFilter()
							}}
						>
							Reset
						</Button>
					</div>
				</div>
				{this.state.analyticsData.length > 0 ? (
					<div>
						<div style={{ marginTop: 10 }}>{this.renderTable(headings, analyticsData)}</div>
					</div>
				) : (
					<text>No Data To Display...</text>
				)}
				{this.state.nextToken != null && (
					<button onClick={this.loadMore} type='button' className='load-more'>
						Load more
					</button>
				)}
			</section>
		)
	}
}

export default ListPages
